import React from 'react';
import {Button, Spinner} from 'reactstrap';

const SpinnerButton = (props) => {
    const {type, submitting, title, disabled, block, color, onClick, className, minWidth, iconClass} = props;

    return (
        <Button
            color={color}
            style={{
                minWidth: minWidth || '91px',
                minHeight: type === 'modal' ? '35px' : '0'
            }}
            type="button"
            className={'btn calltoaction-button btn btn-secondary ' + (className)}
            disabled={disabled}
            block={window.innerWidth < 450 || block}
            onClick={() => !submitting && onClick()}
        >
            {(iconClass && !submitting) && <><i className={iconClass}/>&nbsp;</>}
            {submitting ? <Spinner  style={{height: '1rem', width: '1rem', borderWidth: '2px'}}/> : title}
        </Button>
    );
}

export default SpinnerButton;